import { __makeTemplateObject } from "tslib";
import styled, { css } from 'styled-components';
import { ThemeSelectors } from '@at/design-system-foundation';
var getLozengeColour = function (lozengeColour, theme) {
    switch (lozengeColour) {
        case 'GREAT':
            return ThemeSelectors.getLightGreen(theme);
        case 'GOOD':
            return ThemeSelectors.getGreen(theme);
        case 'FAIR':
            return ThemeSelectors.getLightYellow(theme);
        case 'HIGH':
            return '#FF9A7A';
        case 'LOW':
        default:
            return ThemeSelectors.getDarkDefaultColor(theme);
    }
};
export var StyledPriceIndicatorLozenge = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var theme = _a.theme, lozengeColour = _a.lozengeColour, displayType = _a.displayType;
    var gridUnit = ThemeSelectors.getLegacyGridUnit(theme);
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            border-radius: ", " 0;\n            min-width: ", "px;\n            text-align: center;\n            display: ", ";\n            padding: ", " ", ";\n            color: ", ";\n            background-color: ", ";\n        "], ["\n            border-radius: ", " 0;\n            min-width: ", "px;\n            text-align: center;\n            display: ", ";\n            padding: ", " ", ";\n            color: ", ";\n            background-color: ", ";\n        "])), ThemeSelectors.getGroupTwoSpacing(theme), gridUnit * 10, displayType === 'inline' ? 'inline-block' : 'block', ThemeSelectors.getGroupOneSpacing(theme), ThemeSelectors.getGroupTwoSpacing(theme), lozengeColour === 'GOOD' ? ThemeSelectors.getWhite(theme) : ThemeSelectors.getTitleColor(theme), getLozengeColour(lozengeColour, theme));
});
var templateObject_1, templateObject_2;
